import { Box } from '@mui/material';
import { FooterTemplate } from './FooterTemplate';
import {
  DATENSCHUTZ_LINK,
  IMPRESSUM_LINK,
  AGB_LINK,
  DATENSCHUTZ_LINK_JOBS_DE,
  DATENSCHUTZ_LINK_JOBS_EN,
} from 'constants/pageLinks';

export interface FooterLink {
  caption: string;
  href: string;
}
export interface FooterProps {
  footerLinks?: FooterLink[];
  logoLink?: string;
}

export const defaultFooterLinks: FooterLink[] = [
  { caption: 'Datenschutz', href: DATENSCHUTZ_LINK },
  { caption: 'AGB', href: AGB_LINK },
  { caption: 'Impressum', href: IMPRESSUM_LINK },
];

export const jobsFooterLinks: FooterLink[] = [
  { caption: 'Datenschutz', href: DATENSCHUTZ_LINK_JOBS_DE },
  { caption: 'Privacy Notice', href: DATENSCHUTZ_LINK_JOBS_EN },
  { caption: 'AGB', href: AGB_LINK },
  { caption: 'Impressum', href: IMPRESSUM_LINK },
];

export function Footer(props: FooterProps) {
  const { footerLinks = defaultFooterLinks, logoLink } = props;

  return (
    <Box
      mt={(theme) => theme.spacing(3)}
      borderTop={(theme) => `1px solid ${theme.palette.grey[300]}`}
    >
      <FooterTemplate
        oneTrustHandler={() => window?.OneTrust?.ToggleInfoDisplay()}
        footerLinks={footerLinks}
        logoLink={logoLink}
      />
    </Box>
  );
}
